import React, { PropsWithChildren, FC, useState, useEffect } from 'react';
import { headerMenuItemsRu, LS_KEYS } from 'consts';
import { Header, Footer, Main, CookieBanner } from 'components';
import {
    StickyHeaderStateProvider,
    useConfig,
    useMobileMenuContext,
} from 'contexts';
import { StorageService } from 'services';
import { injectCookiebot } from 'utils';

export const AppLayout: FC<PropsWithChildren> = ({ children }): JSX.Element => {
    const {
        isCorporatePage,
        isProfessionPage,
        isCoursePage,
        isAlliancePage,
        isAcademyAlliancePage,
    } = useMobileMenuContext();

    const { appConfig } = useConfig();
    const storageService = new StorageService();

    const isRuLocale = process.env.REACT_APP_LOCALE === 'ru';
    const isRuCountry = appConfig?.countryCode?.toLowerCase() === 'ru';
    const shouldShowCustomBanner = isRuLocale || isRuCountry;

    const [cookieBannerVisible, setCookieBannerVisible] = useState<boolean>(
        !storageService.getItem<boolean>(LS_KEYS['cookiesSuppressed']) &&
            shouldShowCustomBanner
    );

    useEffect(() => {
        if (appConfig?.countryCode === undefined) {
            return;
        }

        const isSuppressed = storageService.getItem<boolean>(
            LS_KEYS['cookiesSuppressed']
        );

        if (shouldShowCustomBanner) {
            if (!isSuppressed) {
                setCookieBannerVisible(true);
            }
        } else {
            setCookieBannerVisible(false);
            injectCookiebot();
        }
    }, [appConfig?.countryCode, shouldShowCustomBanner]);

    return (
        <>
            <StickyHeaderStateProvider>
                <Header links={headerMenuItemsRu} />
            </StickyHeaderStateProvider>
            <Main
                isCorporatePage={isCorporatePage}
                isProfessionPage={isProfessionPage}
                isCoursePage={isCoursePage}
                isAlliancePage={isAlliancePage}
                isAcademyAlliancePage={isAcademyAlliancePage}>
                {children}
            </Main>
            <Footer
                isCorporatePage={
                    isCorporatePage ||
                    isProfessionPage ||
                    isCoursePage ||
                    isAlliancePage
                }
            />
            {cookieBannerVisible && (
                <CookieBanner
                    accept={() => {
                        storageService.setItem(
                            LS_KEYS['cookiesSuppressed'],
                            true
                        );
                        setCookieBannerVisible(false);
                    }}
                />
            )}
        </>
    );
};

export default AppLayout;
